module.exports = __webpack_public_path__ + "fonts/dFanZfeM_74wlPZtksIFaj8CDHeZWXB3X6_0fw.woff2";